const tabs = document.querySelectorAll('.tab');
const contents = document.querySelectorAll('.content');

tabs.forEach(tab => {
  tab.addEventListener('click', () => {
    const activeTab = tab.getAttribute('data-tab');

    tabs.forEach(t => {
      if (t === tab) {
        t.classList.add('tab-actived'); // Add "actived" class to clicked tab
      } else {
        t.classList.remove('tab-actived'); // Remove "actived" class from other tabs
      }
    });

    contents.forEach(content => {
      if (content.id === activeTab) {
        content.classList.remove('hidden');
      } else {
        content.classList.add('hidden');
      }
    });
  });
});